<template>
    <div id="applicants">
        <v-overlay absolute="" opacity="0.2" :value="loader">
            <v-progress-circular :color="appColor" indeterminate size="32"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar.status" top :color="snackbar.color" :timeout="snackbar.timeout">
            <v-icon class="mr-1">{{ snackbar.icon }}</v-icon> {{ snackbar.message }}
        </v-snackbar>
        <Toolbar />
        <v-container fluid v-if="loadingDone">
            <v-row>
                <v-col cols="12">
                    <Manager :residenceTerm="residenceTerms" :permissions="permission" :defaultResidenceTerm="defaultResidenceTerm" />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import auth from '../../js/auth';
import Toolbar from '../../components/Admin/RoommateMatcher/Toolbar.vue';
import Manager from '../../components/Admin/RoommateMatcher/Manager.vue';

export default {
    name: 'applicants',
    components: {
        Toolbar,
        Manager
    },
    data() {
        return {
            loader: true,
            loadingDone: false,
            permission: {},
            residenceTerms: [],
            defaultResidenceTerm: {},
            snackbar: {
                color: 'success',
                icon: '',
                message: '',
                status: false,
                timeout: 5000
            }
        }
    },
    methods: {
        getResidenceTerm() {
            const that = this;
            that.residenceTerms = [];
            that.loadingDone = false;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getEntity&type=ResidenceTerms`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to use this resource.`, true);
                    } else if (!json.result.match(/OK/i)) {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `Warning: `+json.message, true);
                    }else {
                        json.data.forEach(element => {
                            if(parseInt(element["active"]) == 1){
                                that.residenceTerms.push(element);
                            }

                            if(parseInt(element["default"]) == 1){
                                that.defaultResidenceTerm = element;
                            }
                        });
                    }

                    that.setLoader(false);
                    that.loadingDone = true;
                })
                .catch(function () {
                    that.setLoader(false);
                })
        },
        getPermission() {
            this.permission = auth.getPermission("adminroommatematcher");
        },
        setLoader(bool) {
            this.loader = bool;
        },
        setNotification(color, icon, message, status) {
            // Reset snackbar
            this.snackbar.status = false;

            // Set snackbar fields
            this.snackbar.color = color;
            this.snackbar.icon = icon;
            this.snackbar.message = message;
            this.snackbar.status = status;
        },
    },
    computed: {
        appColor() {
            return '#191b2a';
        }
    },
    created() {
        this.getResidenceTerm();
        this.getPermission();
    }
}
</script>